<template>
  <ul class="menu" v-if="isPortalTypeBooks && !isPortalTypeLoading">
    <li v-for="item in menuPortalTypeBooks">
      <a :href="$getSubdomainLink(item.subdomain, item.route)"
         class="menu__item btn btn-default"
         :class="{
            active: $route.path.includes(item.route),
          }"
      >
        {{ item.name }}
      </a>
    </li>
  </ul>
  <ul class="menu"  v-if="!isPortalTypeBooks && !isPortalTypeLoading">
    <li v-for="item in menuPortalTypeDefault">
      <a :href="$getSubdomainLink(item.subdomain, item.route)"
         class="menu__item btn btn-default"
         :class="{
            active: $route.path.includes(item.route),
          }"
      >
        {{ item.name }}
      </a>
    </li>
  </ul>
</template>

<script>
import { useAuthStore, useEnabledStore } from "@/stores";
export default {
  data() {
    return {
      enabledStore: useEnabledStore(),
      authStore: useAuthStore(),
    };
  },
  computed: {
    menuPortalTypeBooks() {
      return [
        {
          name: 'Books',
          route: '/books/catalog',
          subdomain: 'portal',
          forAuth: false
        }
      ].filter(item => !item.forAuth || this.isAuth)
    },
    menuPortalTypeDefault () {
      return [
        {
          name: 'Plants',
          route: '/plants/catalog',
          subdomain: 'portal',
          forAuth: false
        },
        {
          name: 'Calendar',
          route: '/calendar',
          subdomain: 'portal',
          forAuth: false
        },
        {
          name: 'Glossary',
          route: '/glossary',
          subdomain: 'portal',
          forAuth: true
        },
        {
          name: 'Books',
          route: '/books/catalog',
          subdomain: 'portal',
          forAuth: false
        },
        {
          name: 'Blog',
          route: '/blog/catalog',
          subdomain: 'portal',
          forAuth: false
        }
      ].filter(item => !item.forAuth || this.isAuth)
    },
    isPortalTypeBooks() {
      return this.enabledStore.isPortalTypeBooks;
    },
    isAuth() {
      return this.authStore.isAuth;
    },
    isPortalTypeLoading() {
      return this.enabledStore.isPortalTypeLoading;
    }
  }
};
</script>